/**
 * FEAT-096 — who sees the Newsletter screen.
 *
 * Mirrors the API's newsletter capability gate (apps/api/src/lib/capability-gate.ts,
 * GATED_CAPABILITIES.newsletter). The API is what enforces it; this only
 * decides whether to show the nav item, so the two must agree or a user sees
 * a link that answers 403.
 */

const NEWSLETTER_TENANT_TYPES = new Set(["admin", "internal"]);

export function canSeeNewsletter(tenantType: string | undefined): boolean {
  return tenantType !== undefined && NEWSLETTER_TENANT_TYPES.has(tenantType);
}
